<template>
  <div class="home">
    <div class="page">
      <common-modal 
        v-if="isCommonModal"
        :title="'등록된 환자 정보가 없어요.'"
        :message="message"
        :button1Text="'환자 등록하기'"
        :button2Text="'취소'"
        :buttonCount="2"
        @onClose="onCommonModalClose"
        @onClickButton1="onClickButton1"
        @onClickButton2="onClickButton2"
      />  
      <!-- <common-modal 
          :title="'시스템 점검중'"
          :message="'안녕하세요, 솔닥입니다.<br><br>더 안정적인 서비스 제공을 위해 아래 시간 동안 시스템 점검이 진행될 예정입니다.<br><br>점검 일시: 2026.10.19 월요일 오후 21:00 ~ 23:00<br><br>점검 시간 동안은 서비스 접속 및 이용이 어려울 수 있으며, 점검 완료 후 정상적으로 이용하실 수 있습니다.'"
          :buttonCount="0"
      />    -->
      <TopBar 
       @home-click="gosolcon"
      />
      <div class="mt-24" v-if="!isExpectedDateLoading">
        <CardCarousel :items="electrodeItems" />
      </div>
      <div class="mt-24 banner-list">
        <!-- <BannerSection
          :icon="mallIcon"
          :title="'컨시어지몰'"
          :description="'컨시어지 몰에서 상품구매'"
          :background="'#DCE8F0'"
          @click="goMall"
        /> -->
        <BannerSection
          :icon="inviteIcon"
          :title="'솔닥 컨시어지 초대하기'"
          :description="'친구에게 솔닥을 알려주세요!'"
          :background="'#D8D9F0'"
          @click="goInvite"
        />
      </div>
      <div class="mt-24">
        <MenuList 
        @menu-click="menuClick"
        />
      </div>
      <div class="mt-24">
        <ButtonPair 
          @logout-click="logout"
          @home-click="gosolcon"
        />
      </div>
      <div class="mt-40">
        <AppFooter />
      </div>

    </div>
  </div>
</template>

<script>
import cookies from '@/utilities/cookie.js';
import Constant from '@/constant';
import {mapState} from 'vuex';

import TopBar from '@/components/new/organisms/TopBar.vue'
import CardCarousel from '@/components/new/organisms/CardCarousel.vue'
import BannerSection from '@/components/new/organisms/BannerSection.vue'
import MenuList from '@/components/new/organisms/MenuList.vue'
import ButtonPair from '@/components/new/molecules/ButtonPair.vue'
import AppFooter from '@/components/new/organisms/AppFooter.vue'

import Loading from '@/components/molecules/Loading';
import CommonModal from '@/components/modals/CommonModal';

export default {
  name: 'NewHome',
  components: {
    TopBar,
    CardCarousel,
    BannerSection,
    MenuList,
    ButtonPair,
    AppFooter,
    Loading,
    CommonModal
  },
  computed: mapState(['diabetes_profiles']),
  data: function () {
    return {
      isExpectedDateLoading: false,
      mallIcon: require('@/assets/home/icn_mall_3d.png'),
      inviteIcon: require('@/assets/home/icn_invite_heart.png'),
      electrodeItems: [
        // { name: '홍길동', expected_purchase_date: '2026-05-01' },
        // { name: '김철수', expected_purchase_date: '2026-04-23' },
        // { name: '이영희', expected_purchase_date: '2026-04-10' },
        // { name: '박민수', expected_purchase_date: '2026-05-15' },
        // { name: '최지우', expected_purchase_date: '2026-04-27' },
        // { name: '정수빈', expected_purchase_date: '2026-06-05' },
        // { name: '강동원', expected_purchase_date: '2026-04-18' },
        // { name: '윤서연', expected_purchase_date: '2026-05-20' },
        // { name: '임재현', expected_purchase_date: '2026-04-30' },
        // { name: '송하늘', expected_purchase_date: '2026-05-10' },
      ],
      tempItems: [
        {
          profile_id: 0,
          name: "홍길동",
          purchase_dates: [
            {
              type: "electrode",
              expected_purchase_date: "2026-06-15T08:03:04.889Z"
            },
            {
              type: "expendable",
              expected_purchase_date: "2026-06-12T08:03:04.889Z"
            },
            {
              type: "catheter",
              expected_purchase_date: "2026-06-01T08:03:04.889Z"
            }
          ]
        },
        {
          profile_id: 1,
          name: "김철수",
          purchase_dates: [
            {
              type: "electrode",
              expected_purchase_date: "2026-06-15T08:03:04.889Z"
            },
            {
              type: "expendable",
              expected_purchase_date: "2026-06-12T08:03:04.889Z"
            }
          ]
        },
        {
          profile_id: 2,
          name: "이영희",
          purchase_dates: [
            {
              type: "electrode",
              expected_purchase_date: "2026-06-15T08:03:04.889Z"
            }
          ]
        }
      ],
      access_token: null,
      isLoading: false,
      message: "환자 정보를 먼저 등록해 주세요.<br>‘환자 등록하기' 버튼을 클릭하여 이용해 주세요.",
      isCommonModal: false,
      kakaoId: null,
      phoneNumber: null,
      error: null,
      isOutlinkPopup: false,
      outLink: null,
      isProfileLoading: false,
      profileData: null,
      isNotification: true,
      multipleProfiles: false,
      name: '',
      birth: '',
      mobileNumber: "",
      delegate: "",
      delegateStartDate: '',
      diabetesType: '',
      address: '',
      card: '',
      lastCheckoutCompletedAt: '',
      purchasedCount: 0,
      mkt: false
    }
  },
  mounted: async function()
  {
    this.access_token = cookies.getLocalStorage("access_token");

    if(this.access_token === null || this.access_token === undefined || this.access_token === '')
    {      
        this.access_token = cookies.deleteLocalStorage("access_token");
        this.$router.push({path: '/', query: {returnUrl: 'home'}})
    }
    else
    {
      if(this.diabetes_profiles.length === 0)
      {          
          this.isLoading = true;          
      }
      else 
      {
          this.profileData = this.diabetes_profiles;
      }

      this.isExpectedDateLoading = true;
      this.$store.dispatch(Constant.FETCH_EXPECTED_DATE, {token: this.access_token})
          .then((res) => {
            
              this.electrodeItems = this.buildElectrodeItems(res)
              this.isExpectedDateLoading = false;
          })
          .catch(() => {
              this.isExpectedDateLoading = false;
              this.access_token = cookies.deleteLocalStorage("access_token");
              this.$router.push({path: '/', query: {returnUrl: 'home'}})
          })

      // 유효성 체크    
      this.$store.dispatch(Constant.FETCH_PROFILES, {token: this.access_token})
        .then((res) => {
      
                this.profileData = res;
                this.channelTalkProfileDataSplit(this.profileData);
                  ChannelIO('boot', {
                    "pluginKey": "90e69520-1088-43c6-a1cc-3019437a9be8",
                    profile: {
                        multipleProfiles: this.multipleProfiles,
                        name: this.name,
                        birth: this.birth,
                        mobileNumber: this.mobileNumber,
                        delegate: this.delegate,
                        delegateStartDate: this.delegateStartDate,
                        diabetesType: this.diabetesType,
                        address: this.address,
                        card: this.card,
                        lastCheckoutCompletedAt: this.lastCheckoutCompletedAt,
                        purchasedCount: this.purchasedCount,
                        mkt: this.mkt
                    },
                    language: 'ko'
                });

                this.isLoading = false;
                    
        }) 
        .catch(() => {
            this.access_token = cookies.deleteLocalStorage("access_token");
            this.$router.push({path: '/', query: {returnUrl: 'home'}})
            this.isLoading = false;
        })
    }
  },
  methods: {
    buildElectrodeItems: function (data) {
      if (!data || !data.length) return []
      var items = []
      for (var i = 0; i < data.length; i++) {
        var profile = data[i]
        var purchaseDates = profile.purchase_dates || []
        var purchases = []
        for (var j = 0; j < purchaseDates.length; j++) {
          var purchase = purchaseDates[j]
          if (purchase.expected_purchase_date !== null) {
            purchases.push({
              type: purchase.type,
              date: purchase.expected_purchase_date
            })
          }
        }
        if (purchases.length) {
          items.push({
            name: profile.name,
            purchases: purchases
          })
        }
      }
      return items
    },
    goMall() {
      this.$router.push({path: '/mall'})
    },
    goInvite() {
      this.$router.push({path: '/invite'})
    },
    channelTalkProfileDataSplit: function(profile)
    {
        if(profile === null || profile.length === 0)
        {
            return;
        }

        const first = profile[0];
        this.multipleProfiles = profile.length > 1;

        if(this.multipleProfiles)
        {
            // 복수 프로필: 이름만 모두 표시, 나머지 빈값
            this.name = profile.map(p => p.profile.name).join(', ');
            return;
        }

        // 단일 프로필
        this.name = first.profile.name;

      
        // birth (registration_number에서 파싱)
        if(first.profile.registration_number)
        {
            const regNum = first.profile.registration_number;
            const yy = regNum.substring(0, 2);
            const mm = regNum.substring(2, 4);
            const dd = regNum.substring(4, 6);
            const genderDigit = regNum.substring(6, 7);
            const century = (genderDigit === '1' || genderDigit === '2') ? '19' : '20';
            this.birth = `${century}${yy}-${mm}-${dd}`;
        }

        // mobileNumber
        this.mobileNumber = `+82${first.profile.phone_number}`;

        if(first.delegation_info !== null)
        {
          // delegate
          if(first.delegation_info.is_delegated)
          {
            
              this.delegate = '위임함';
              this.delegateStartDate = first.delegation_info.started_at.substring(0, 10);
          }
          else
          {
            
              this.delegate = '위임안함';
          }

        }
        else
        {
          this.delegate = '위임안함';
        }


        // diabetesType
        const typeMap = {
            'TYPE1': '1형당뇨',
            'TYPE2': '2형당뇨',
            'GESTATIONAL': '임신성당뇨(투여)',
            'GESTATIONAL_WITHOUT_INSULIN': '임신성당뇨(미투여)',
            'RARE_INTRACTABLE': '희귀난치성질환',
            'SELF_CATHETER': '자가도뇨 카테터'
        };

        this.diabetesType = typeMap[first.profile.diabetes_type] || '';

        // address
        this.address = `${first.profile.address === null ? '입력안함' : first.profile.address} ${first.profile.address_description === null ? '' : first.profile.address_description}`;

        // card
        if(first.card_info !== null)
        {
            this.card = first.card_info.card_name + ' ' + first.card_info.card_number;
        }
        else
        {
            this.card = '카드미등록';
        }
    },  
    menuClick: function(item)
    {
      if(item.id === 1)
      {
        this.$router.push({path: '/register'})
      }
      else if(item.id === 2)
      {
        if(this.diabetes_profiles.length > 0)
        {
          this.$router.push({path: '/apply'})
        }
        else
        {
          // 등록된 환자 정보가 없어요 모달 
          this.isCommonModal = true;
        }
      }
      else if(item.id === 3)
      {
        if(this.diabetes_profiles.length > 0)
        {
          this.$router.push({path: '/info'})
        }
        else
        {
          // 등록된 환자 정보가 없어요 모달 
          this.isCommonModal = true;                
        }
      }
      else if(item.id === 4)
      {
        if(this.diabetes_profiles.length > 0)
        {
          this.$router.push({path: '/settlement'})
        }
        else
        {
          // 등록된 환자 정보가 없어요 모달 
          this.isCommonModal = true;                
        }
      }
    },
    gosolcon: function()
    {
      window.location.href = "https://soldoccon.co.kr";
    },
    logout: function()
    {
      this.access_token = cookies.deleteLocalStorage("access_token");
      window.location.href = "https://soldoccon.co.kr";
    },
    onCommonModalClose: function()
    {
        this.isCommonModal = false;
    },
    onClickButton1: function()
    {
        this.isCommonModal = false;
        this.$router.push({path: '/register'})            
    },
    onClickButton2: function()
    {
        this.isCommonModal = false;
    },
  },
}
</script>

<style scoped>
  .home {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    
  }
  .page {
    width: 100%;
    background: #F2F4F6;
  }
  .banner-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .mt-8 { margin-top: 8px; }
  .mt-12 { margin-top: 12px; }
  .mt-16 { margin-top: 16px; }
  .mt-20 { margin-top: 20px; }
  .mt-24 { margin-top: 24px; }
  .mt-32 { margin-top: 32px; }
  .mt-40 { margin-top: 40px; }
  @media (min-width: 600px) {
    .page {
        width: 600px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/new/Home.vue